/**
 * List all possible commands the system is capable of processing.
 */
export enum AsyncServiceRequestName {
  e164Phone = 'e164Phone',
}

export type AsyncServiceRequestNameType = keyof typeof AsyncServiceRequestName;
